module.exports = __webpack_public_path__ + "static/media/files-medical.8dea5e36.svg";